import useOpenLeadModal from 'components/domain/lead/modal/useOpenLeadModal';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { getBestProfile } from 'utils/user/userUtils';
import { LeadCellButtonStyled } from './LeadCell.styles';
import useFetchLeadForLeadCell from './useFetchLeadForLeadCell';

interface LeadCellProps {
  getValue: () => string;
}

const LeadCell = ({ getValue }: LeadCellProps) => {
  const leadUid = getValue();
  const { updateLeadModal: openUpdateLeadModal } = useOpenLeadModal();
  const { lead, isFetching } = useFetchLeadForLeadCell({ leadUid });

  if (isFetching) {
    return <LoadingPlaceholder />;
  }

  return (
    <LeadCellButtonStyled
      bsStyle="link"
      disabled={!lead}
      onClick={() => openUpdateLeadModal({ leadUid })}
    >
      {getBestProfile(lead ?? undefined) || '-'}
    </LeadCellButtonStyled>
  );
};

export default LeadCell;
